import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as alertsActions from '../Actions/alertsActions';
import AlertList from "../Components/Alert/AlertList";
import { alertService } from "../Services/AlertService.js";
import {searchFilterService} from "../Services/SearchFilterService.js";

class AlertListConteiner extends Component {
	constructor(props){
		super(props);
		
		this.handleSolveAlert=this.handleSolveAlert.bind(this);
	}
	
	componentDidMount() {
//		if(this.props.isLoggedIn){
			alertService.listAlerts()
					.then(response => {return this.props.actions.fetchAlertRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
//		}
	}
	
	handleSolveAlert(alertId){
		//console.log("AlertListConteiner.handleSolveAlert: "+alertId);
		alertService.solveAlert(this.props.alertRecords.find(al => {if(al.id === alertId){ return true;}}))
					.then(response => {return this.props.actions.fetchAlertRecord(response.data);})
					.catch(err => {/*console.log(err);*/});
	}
	
	render(){
	    return (<AlertList  alertRecords={this.props.alertRecords}
							handleSolveAlert={this.handleSolveAlert}/>);
	}
}

function mapStateToProps(state, ownProps) {  
	return {alertRecords: state.alerts,
//			isLoggedIn: state.user.logedIn,
			user: state.user}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(alertsActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertListConteiner);  